module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="header_top">\n    <div class="first_block clearfix">\n        <img class="cmg_logo" src="img/logo_blanche_kengroup.png" alt="Logo Resamania" />\n        <div class="navlink planning active">Planning</div>\n        <div class="navlink coachLink">Coachs</div>\n        <div class="current_hour"></div>\n    </div>\n</div>\n\n<div class="header_bottom">\n    <div class="second_block">\n        <div class="daysanddate_list"></div>\n    </div>\n    <div class="third_block">\n        <div class="filter_info">\n            <span>Afficher par :</span>\n        </div>\n        <div class="filters"></div>\n    </div>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="header_top">\n    <div class="first_block clearfix">\n        <img class="cmg_logo" src="img/logo_blanche_kengroup.png" alt="Logo Resamania" />\n        <div class="navlink planning active">Planning</div>\n        <div class="navlink coachLink">Coachs</div>\n        <div class="current_hour"></div>\n    </div>\n</div>\n\n<div class="header_bottom">\n    <div class="second_block">\n        <div class="daysanddate_list"></div>\n    </div>\n    <div class="third_block">\n        <div class="filter_info">\n            <span>Afficher par :</span>\n        </div>\n        <div class="filters"></div>\n    </div>\n</div>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1714121726-2.1.11/node_modules/ejs-compiled-loader!./src/templates/header.ejs
// module id = 128
// module chunks = 0